/* src/app/components/admin/server-config/server-config-item/server-config-item.component.scss */
mat-form-field {
  flex-grow: 1;
  padding: 0px 2px;
}
/*# sourceMappingURL=server-config-item.component.css.map */
